import { render, staticRenderFns } from "./Countdown.vue?vue&type=template&id=3dfaceea&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"
import style0 from "./Countdown.vue?vue&type=style&index=0&id=3dfaceea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfaceea",
  null
  
)

export default component.exports